import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "../../utils/common";
import {
    ReactCompareSlider,
    ReactCompareSliderImage,
    ReactCompareSliderHandle,
} from "react-compare-slider";
import { useDispatch } from "react-redux";
import { clearAiMhDetails } from "../../store/AiMarketingHub/AimhLandingPage/AimhLpReducer";
import axios from "axios";
import { saveAs } from "file-saver";
import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import Loader from "../Utilities/Loader";
import { useHistory } from "react-router-dom";
import { httpRequest } from "../../utils/networkCalls";

export default function Success({ setIsActive, userDetails, propStype = "", ...props }) {
    const dispatch = useDispatch();
    // useEffect(() => {
    //     if (window.gtag) {
    //         window.gtag('set', 'page_path', `/user-dashboard${window.location.hash}`);
    //         window.gtag('event', 'page_view');
    //     }
    //     console.log(`/user-dashboard${window.location.hash}`)
    // }, [])
    const [isFlyerDownloading, setIsFlyerDownloading] = useState(false);
    const [isVideoDownloading, setIsVideoDownloading] = useState(false);
    const [userEmail, setUserEmail] = useState("");
    const history = useHistory();
    useEffect(() => {
        setUserEmail(userDetails.email);
        // if (propStype === "banner") {
        //     console.log(propStype);
        // }
    }, []);

    const query = useQuery();
    // console.log(
    //     "SUCCESS PAGE",
    //     query.get("stype"),
    //     query.get("order-id"),
    //     window.location.href,
    //     userDetails
    // );

    function urlToPromise(url) {
        return new Promise(function (resolve, reject) {
            JSZipUtils.getBinaryContent(url, function (err, data) {
                if (err) {
                    reject(err);
                } else {
                    resolve(data);
                }
            });
        });
    }

    const downloadFlyer = async (oid, finalFlyerImgUrl, scaledFlyerImg) => {
        let fileName =
            oid +
            `.${finalFlyerImgUrl
                .substring(finalFlyerImgUrl.lastIndexOf("/") + 1)
                .split(".")[1]
            }`;

        let zip = new JSZip();

        zip.file(`Regular_image.${finalFlyerImgUrl.substring(finalFlyerImgUrl.lastIndexOf("/") + 1).split(".")[1]}`, urlToPromise(finalFlyerImgUrl), { binary: true });
        zip.file("High_resolution_image.jpg", urlToPromise(scaledFlyerImg), {
            binary: true,
        });

        let zipBlob = await zip.generateAsync({ type: "blob" });

        saveAs(zipBlob, "FylerImage.zip");
        setIsFlyerDownloading(false);
    };

    async function getOrderDataAndDownloadVideo(){
        const staging_data = await httpRequest(`/staging/${query.get("order-id")}`, 'get');

        const fs = staging_data.data;

        if(fs.payment !== 'NA' && fs.status === 'completed'){
            downloadVideo(fs);
        }
    }

    const PaymentSuccessTracker = () => {
    try {
      const stype = query.get("stype") || propStype;
      const orderId = query.get("order-id") || '';
      const user = JSON.parse(localStorage.getItem("user"));

      const payload = {
        utm_source: localStorage.getItem("utm_source") || "",
        utm_medium: localStorage.getItem("utm_medium") || "",
        utm_campaign: localStorage.getItem("utm_campaign") || "",
        utm_term: localStorage.getItem("utm_term") || "",
        page_url: window.location.href,
        order_id: orderId || "",
        service: stype || "",
        email_id: user?.email || "",
        amount: localStorage.getItem("order_amount") || "",
        num_of_imgs: localStorage.getItem("number_of_img") || "",
      };

      if (!payload.utm_source) return;
        const formBody = new URLSearchParams(payload).toString();
        axios
          .post(
            "https://script.google.com/macros/s/AKfycbzIiDsQild9Q8xPPEHZa3qCeGrYGVUDYohDMFEhv4ZFMISAENA204PSRiHq5gw8bhBhVQ/exec",
            formBody,
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            }
          )
          .then(() => {
            localStorage.removeItem('utm_source');
            localStorage.removeItem('utm_medium');
            localStorage.removeItem('utm_campaign');
            localStorage.removeItem('utm_term');
            localStorage.removeItem('order_id');
            localStorage.removeItem('service_type');
            localStorage.removeItem('order_amount');
            localStorage.removeItem('number_of_img');
        })
          .catch((err) => console.error(err));
        }
        catch {
            console.log('error tracking data')
        }
    };

    async function downloadVideo(formSchema){
            // console.log(email);
            setIsVideoDownloading(true);
            try {

                let interval = setInterval(async () => {

                    let res = await httpRequest(`/automated_video/getVideoById/${formSchema.orderID}`, 'get');
                    
                    if(res?.data?.status === 'completed' && !res?.data?.isWatermarkApplied){
                        const aElement = document.createElement('a');
                        aElement.setAttribute('download', true);
                        aElement.href = res.data.url;
                        aElement.click();
                        aElement.remove();
                        setIsVideoDownloading(false);
                        
                        clearInterval(interval);
                    }
                }, 5000)

            } catch (err) {
                console.log(err);
            }
        
    }
    useEffect(() => {
        if (query.get("stype") === "banner") {
            setIsFlyerDownloading(true);
            let interval = setInterval(() => {
                axios
                    .get(
                        `https://staging-api.styldod.com/api_v2/banner_order/${query.get(
                            "order-id"
                        )}`
                    )
                    .then((response) => {
                        // console.log(
                        //     "fjdalskfj;alsdf",
                        //     response.data.data.bannerRes.scaledImg
                        // );
                        if (
                            response.data.data.bannerRes.scaledImg !==
                            undefined &&
                            response.data.data.bannerRes.scaledImg !== ""
                        ) {
                            // console.log("done");
                            downloadFlyer(
                                query.get("order-id"),
                                response.data.data.bannerRes.finalImgUrl,
                                response.data.data.bannerRes.scaledImg
                            );
                            clearInterval(interval);
                        }
                    }).catch((error) => {
                        clearInterval(interval);
                        console.error(error)
                    })
            }, 2000);
        } else if(query.get("stype") === 'video_maker'){
            getOrderDataAndDownloadVideo();
            console.log('downloading...')
        }
        PaymentSuccessTracker();
    }, []);

    const stype = query.get("stype") || propStype;
    const [btnTxt, setBtnText] = useState("Get your invite link");
    const initRc = (d, s, id) => {
        let js,
            fjs = d.getElementsByTagName(s)[0];
        js = d.createElement(s);
        js.id = id;
        js.defer = true;
        js.src =
            "//portal.referralcandy.com/assets/widgets/refcandy-lollipop.js";
        fjs.parentNode.insertBefore(js, fjs);
    };
    return (
        <>
            <div
                id="refcandy-lollipop"
                data-id="gc8inv4cvdjreh6112lwmfaru"
                data-fname={userDetails.name}
                // data-lname="vvv"
                data-email={userEmail}
                data-accepts-marketing="true"
            ></div>
            {isFlyerDownloading ? (
                <div className="ud-mask-container">
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "20px",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Loader type={"spin"} color={"#a6df50"} />
                        <p style={{ fontSize: "24px", fontFamily: "poppins" }}>
                            Your Flyer is Downloading...
                        </p>
                    </div>
                </div>
            ) : (
                ""
            )}
            {isVideoDownloading && (<>
                <div className="ud-mask-container">
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "20px",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Loader type={"spin"} color={"#a6df50"} />
                        <p style={{ fontSize: "24px", fontFamily: "poppins" }}>
                            Your Video is Downloading...
                        </p>
                    </div>
                </div>
            </>)}
            <div className="wf-section">
                <div className="container-21 w-container">
                    <div className="div-block-331">
                        <div className="div-block-330">
                            <img
                                src="https://assets.website-files.com/5dcf94bbedfe6a0469634ea8/60925dda13ab5532cc9b266d_Group%20238%402x.png"
                                loading="lazy"
                                alt=""
                                className="image-357 div-block-330"
                            />
                        </div>
                        <div className="text-block-new">Payment Successful</div>
                        {stype === "subscription" ? (
                            <div className="new-pay-txt">
                                Thank you for joining AI Marketing Hub
                                <br />
                                Enjoy unlimited usage of AI Marketing Hub's
                                benefits. Your credit card/bank will reflect a
                                payment from PayPal *Styldod Inc.
                            </div>
                        ) : (
                            <div className="new-pay-txt">
                                Thank you for placing your order with us.{" "}
                                {stype !== "video_maker" &&
                                    "We will be processing your order soon. We will notify you on your email address once your order is ready."}
                            </div>
                        )}
                        {stype === "subscription" ? (
                            <Link
                                onClick={() => dispatch(clearAiMhDetails())}
                                className="ud-aimh-ps-btn-cont"
                                to={"/ai-marketinghub"}
                            >
                                <div className="ud-aimh-ps-btn">
                                    Go to AI Marketing Hub
                                </div>
                            </Link>
                        ) : (
                            <>
                                <div
                                    id="dbText"
                                    className="text-block-1073"
                                    style={{ marginBottom: "24px" }}
                                >
                                    <strong className="bold-text-91">
                                        You can view your{" "}
                                        {stype === "video_maker" ||
                                            stype === "video-maker"
                                            ? "video"
                                            : "order"}{" "}

                                        anytime in
                                    </strong>
                                    <Link
                                        to={
                                            stype === "video_maker" ||
                                                stype === "video-maker"
                                                ? "/history"
                                                :
                                                stype === "banner"
                                                    ? "/history"
                                                    : `${query.get("order-id")
                                                        ? `/my-orders?order-id=${query.get(
                                                            "order-id"
                                                        )}`
                                                        : "/my-orders"
                                                    }`
                                        }
                                        style={{
                                            textDecoration: "none",
                                            margin: "auto",
                                            display: "contents",
                                        }}
                                        onClick={(e) =>
                                            setIsActive("My Orders")
                                        }
                                        className="action-btn-2 prestepa w-button"
                                    >
                                        <span className="my-orders-txt">
                                            <strong className="bold-text-565">
                                                {" "}
                                                {stype === "video_maker" ||
                                                    stype === "video-maker"
                                                    ? "history"
                                                    :
                                                    stype === "banner"
                                                        ? "history"
                                                        : "My Orders"}
                                            </strong>
                                        </span>{" "}
                                    </Link>{" "}
                                    <strong className="bold-text-91">
                                        {" "}
                                        On the dashboard.{" "}
                                    </strong>
                                </div>

                                {/* <div id="dbText" className="text-block-1073">
                                <strong className="bold-text-91">
                                Maximize your listing potential with  
                                </strong>
                                <Link
                                    to={`/ai-marketinghub`}
                                    style={{
                                        textDecoration: "none",
                                        margin: "auto",
                                        display: "contents",
                                    }}
                                    onClick={(e) => setIsActive("My Orders")}
                                    className="action-btn-2 prestepa w-button"
                                >
                                    <span className="my-orders-txt">
                                        <strong className="bold-text-565">
                                            {" "}
                                        AI Marketing Hub
                                        </strong>
                                    </span>{" "}
                                </Link>{" "}
                                <strong className="bold-text-91">
                                    {" "}
                                    On the dashboard.{" "}
                                </strong>
                            </div> */}
                            </>
                        )}
                        <a
                            id="cta"
                            href="#"
                            className="place-order-cta-4 ps-db-btn hidden w-button"
                        >
                            GO TO&nbsp;DASHBOARD
                        </a>
                    </div>
                    <Link
                        to={"/ai-marketinghub"}
                        className="ud-pymt-aimh-banner-wrap"
                    >
                        <fieldset className="ud-pymt-aimh-banner">
                            <legend>
                                <div className="ud-pymt-aimh-banner-new-legend">
                                    New
                                </div>
                            </legend>
                            <>
                                <div className="ud-pymt-aimh-banner-title-cont">
                                    <div className="ud-pymt-aimh-banner-title-dash"></div>
                                    <div className="ud-pymt-aimh-banner-title">
                                        AI Marketing Hub
                                    </div>
                                </div>
                                <div className="ud-pymt-aimh-banner-desc-cont">
                                    <div className="ud-pymt-aimh-banner-desc">
                                        Discover our new AI Marketing Hub -
                                        Instantly create property descriptions,
                                        emails &amp; social content!
                                    </div>
                                    <div className="ud-pymt-aimh-banner-desc-arr-icon">
                                        <img
                                            src="https://assets.website-files.com/5dcf94bbedfe6a0469634ea8/644770139f2e777e505efb82_Frame%201000001738.svg"
                                            loading="lazy"
                                            alt=""
                                        />
                                    </div>
                                </div>
                            </>
                        </fieldset>
                    </Link>
                </div>
            </div>

            {stype === "subscription" || (
                <>
                    <div className="refer-div">
                        <div className="ref-div1">
                            <div className="get-off-txt">Get 20% off</div>
                            <div className="refer-txt">
                                Refer your friends to give and get 20% off on
                                the next order.
                            </div>
                        </div>
                        <div className="ref-div2">
                            <div className="enter-txt">
                                Please enter Your E-mail address*
                            </div>
                            <div className="form-block-20 w-form">
                                <form
                                    id="email-form"
                                    name="email-form"
                                    data-name="Email Form"
                                    method="get"
                                    aria-label="Email Form"
                                    data-hs-cf-bound="true"
                                >
                                    <input
                                        type="text"
                                        onChange={(e) =>
                                            setUserEmail(e.target.value)
                                        }
                                        value={userEmail}
                                        className="refer-input-field w-input"
                                        maxLength="256"
                                        name="name"
                                        data-name="Name"
                                        placeholder=""
                                        id="name"
                                    />
                                </form>
                                <div
                                    className="w-form-done"
                                    tabIndex="-1"
                                    role="region"
                                    aria-label="Email Form success"
                                >
                                    <div>
                                        Thank you! Your submission has been
                                        received!
                                    </div>
                                </div>
                                <div
                                    className="w-form-fail"
                                    tabIndex="-1"
                                    role="region"
                                    aria-label="Email Form failure"
                                >
                                    <div>
                                        Oops! Something went wrong while
                                        submitting the form.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="ref-div3">
                            <div
                                className="invite-link-btn w-button"
                                style={
                                    /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
                                        userEmail
                                    )
                                        ? {}
                                        : { cursor: "not-allowed" }
                                }
                                onClick={() => {
                                    if (
                                        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
                                            userEmail
                                        )
                                    ) {
                                        initRc(
                                            document,
                                            "script",
                                            "refcandy-lollipop-js"
                                        );
                                        setBtnText("Loading...");
                                        setTimeout(() => {
                                            setBtnText("Get your invite link");
                                            document.getElementsByTagName(
                                                "body"
                                            )[0].lastChild.lastChild.style.width =
                                                "100%";
                                            document.getElementsByTagName(
                                                "body"
                                            )[0].lastChild.lastChild.style.left =
                                                "0";
                                        }, 3000);
                                    }
                                }}
                            >
                                {btnTxt}
                            </div>
                        </div>
                    </div>

                    <div className="cross-sell-sec wf-section">
                        <div className="listing-div">
                            <div className="listing-txt">
                                Take your listing from good to great!
                            </div>
                            <div className="tu-ar-txt">
                                With best prices in the industry and a quick
                                turnaround time.
                            </div>
                        </div>
                        <div className="cs-cards-div2">
                            <div className="w-row">
                                <div className="column-264 w-col w-col-6">
                                    <div className="cs-card3-div">
                                        <div className="cs-slider-div1">
                                            <ReactCompareSlider
                                                handle={
                                                    <ReactCompareSliderHandle
                                                        linesStyle={{
                                                            opacity: 0,
                                                        }}
                                                    />
                                                }
                                                itemOne={
                                                    <ReactCompareSliderImage
                                                        src="https://cdn.styldod.com/feassets/webflow/icons/common/daytodusk+before.png"
                                                        alt="Image one"
                                                    />
                                                }
                                                itemTwo={
                                                    <ReactCompareSliderImage
                                                        src="https://cdn.styldod.com/feassets/webflow/icons/common/daytodusk+after.png"
                                                        alt="Image two"
                                                    />
                                                }
                                            />

                                            {/* <div className="html-embed-145 w-embed w-script">
                                        <div id="beer-slider1" className="beer-slider beer-ready" data-beer-label="AFTER">
                                            <img src="https://cdn.styldod.com/feassets/webflow/icons/common/daytodusk+after.png"
                                                loading="lazy" alt="VirtualStaging-After" />
                                            <div className="beer-reveal" data-beer-label="BEFORE" style={{ width: "50%" }}>
                                                <img src="https://cdn.styldod.com/feassets/webflow/icons/common/daytodusk+before.png"
                                                    loading="lazy" alt="VirtualStaging-Before" style={{ width: "596px" }} />
                                            </div>
                                            <input type="range" className="beer-range" aria-label="Percent of revealed content"
                                                aria-valuemin="0" aria-valuemax="100" aria-valuenow="50" value="50" min="0"
                                                max="100" /><span className="beer-handle" style={{ left: "50%" }}></span>
                                        </div>

                                        <script>
                                            var slider1 = new BeerSlider(document.getElementById("beer-slider1"));
                                        </script>
                                    </div> */}
                                        </div>
                                        <div className="cs-card-div2">
                                            <div className="cs-pv-div">
                                                <div className="pv-txt">
                                                    Day to Dusk
                                                </div>
                                            </div>
                                            <div className="listing-story-div">
                                                <div className="cs-ls-div">
                                                    <div className="text-block-1074">
                                                        <span className="list-span">
                                                            Outshine your
                                                            listings
                                                        </span>
                                                        <br />
                                                        with dusk hour shot
                                                    </div>
                                                </div>
                                                <div className="cs-price-div">
                                                    <div className="cs-price-txt">
                                                        <span>
                                                            <sup>$</sup>
                                                        </span>
                                                        4
                                                    </div>
                                                    <div className="per-web-txt">
                                                        per image
                                                    </div>
                                                </div>
                                            </div>
                                            <a
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                href="/day-to-dusk"
                                                className="cs-explore-btn w-button"
                                            >
                                                Explore now
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="column-264 w-col w-col-6">
                                    <div className="cs-card4-div">
                                        <div className="cs-slider-div2">
                                            <ReactCompareSlider
                                                handle={
                                                    <ReactCompareSliderHandle
                                                        linesStyle={{
                                                            opacity: 0,
                                                        }}
                                                    />
                                                }
                                                itemOne={
                                                    <ReactCompareSliderImage
                                                        src="https://cdn.styldod.com/feassets/webflow/icons/common/Floorplan+before.png"
                                                        alt="Image one"
                                                    />
                                                }
                                                itemTwo={
                                                    <ReactCompareSliderImage
                                                        src="https://cdn.styldod.com/feassets/webflow/icons/common/Floorplan+after.png"
                                                        alt="Image two"
                                                    />
                                                }
                                            />
                                        </div>
                                        <div className="cs-card-div2">
                                            <div className="cs-pv-div">
                                                <div className="pv-txt">
                                                    Floor plan
                                                </div>
                                            </div>
                                            <div className="listing-story-div">
                                                <div className="cs-ls-div txt2">
                                                    <div className="text-block-1074 txt3">
                                                        <span className="list-span">
                                                            Help buyers
                                                            visualize the layout{" "}
                                                        </span>
                                                        of their dream home
                                                    </div>
                                                </div>
                                                <div className="cs-price-div">
                                                    <div className="cs-price-txt">
                                                        <span>
                                                            <sup>$</sup>
                                                        </span>
                                                        9
                                                    </div>
                                                    <div className="per-web-txt">
                                                        per storey
                                                    </div>
                                                    <div className="hm-ap-txt">
                                                        (home/apt.)
                                                    </div>
                                                </div>
                                            </div>
                                            <a
                                                href="/floor-plan"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="cs-explore-btn w-button"
                                            >
                                                Explore now
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="cs-cards-div">
                            <div className="columns-131 w-row">
                                <div className="cs-card-col1 w-col w-col-6">
                                    <div className="cs-card-div">
                                        <div className="cs-card-div1">
                                            <img
                                                src="https://assets.website-files.com/5dcf94bbedfe6a0469634ea8/62c7f7e7b026f00d7722eee0_Group%202507.png"
                                                loading="lazy"
                                                srcSet="https://assets.website-files.com/5dcf94bbedfe6a0469634ea8/62c7f7e7b026f00d7722eee0_Group%25202507-p-500.png 500w, https://assets.website-files.com/5dcf94bbedfe6a0469634ea8/62c7f7e7b026f00d7722eee0_Group%25202507-p-800.png 800w, https://assets.website-files.com/5dcf94bbedfe6a0469634ea8/62c7f7e7b026f00d7722eee0_Group%25202507-p-1080.png 1080w, https://assets.website-files.com/5dcf94bbedfe6a0469634ea8/62c7f7e7b026f00d7722eee0_Group%202507.png 1133w"
                                                sizes="(max-width: 479px) 100vw, (max-width: 767px) 90vw, (max-width: 991px) 47vw, (max-width: 1439px) 41vw, (max-width: 1919px) 42vw, 44vw"
                                                alt=""
                                                className="cs-card1-img"
                                            />
                                        </div>
                                        <div className="cs-card-div2">
                                            <div className="cs-pv-div">
                                                <div className="pv-txt">
                                                    Property Videos
                                                </div>
                                            </div>
                                            <div className="listing-story-div">
                                                <div className="cs-ls-div">
                                                    <div className="text-block-1074">
                                                        <span className="list-span">
                                                            Share your listing's
                                                            story
                                                        </span>
                                                        <br />
                                                        in high definition
                                                    </div>
                                                </div>
                                                <div className="cs-free-div">
                                                    <div className="cs-free-txt">
                                                        Free<sup>*</sup>
                                                    </div>
                                                </div>
                                            </div>
                                            <Link
                                                // target="_blank"
                                                // rel="noopener noreferrer"
                                                // href="/real-estate-video-maker"
                                                // to="/services?stype=video_maker"
                                                to={{ pathname: '/services', stype: 'video_maker' }}
                                                className="cs-explore-btn w-button"

                                            >
                                                Explore now
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="column-264 w-col w-col-6">
                                    <div className="cs-card2-div">
                                        <div className="cs-card2-img-div">
                                            <img
                                                src="https://assets.website-files.com/5dcf94bbedfe6a0469634ea8/62c7f7e7b026f0a17022eee5_Group%202502.png"
                                                loading="lazy"
                                                srcSet="https://assets.website-files.com/5dcf94bbedfe6a0469634ea8/62c7f7e7b026f0a17022eee5_Group%25202502-p-500.png 500w, https://assets.website-files.com/5dcf94bbedfe6a0469634ea8/62c7f7e7b026f0a17022eee5_Group%25202502-p-800.png 800w, https://assets.website-files.com/5dcf94bbedfe6a0469634ea8/62c7f7e7b026f0a17022eee5_Group%25202502-p-1080.png 1080w, https://assets.website-files.com/5dcf94bbedfe6a0469634ea8/62c7f7e7b026f0a17022eee5_Group%202502.png 1132w"
                                                sizes="(max-width: 479px) 100vw, (max-width: 767px) 90vw, (max-width: 991px) 47vw, (max-width: 1439px) 41vw, (max-width: 1919px) 42vw, 44vw"
                                                alt=""
                                                className="cs-card2-img"
                                            />
                                        </div>
                                        <div className="cs-card-div2">
                                            <div className="cs-pv-div">
                                                <div className="pv-txt">
                                                    Single Property Website
                                                </div>
                                            </div>
                                            <div className="listing-story-div">
                                                <div className="cs-ls-div">
                                                    <div className="text-block-1074">
                                                        <span className="list-span">
                                                            Raise your listings
                                                        </span>
                                                        <br />
                                                        above the competition
                                                    </div>
                                                </div>
                                                <div className="cs-price-div">
                                                    <div className="cs-price-txt">
                                                        <span>
                                                            <sup>$</sup>
                                                        </span>
                                                        30
                                                    </div>
                                                    <div className="per-web-txt">
                                                        per website
                                                    </div>
                                                </div>
                                            </div>
                                            <a
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                href="/single-property-website"
                                                className="cs-explore-btn w-button"
                                            >
                                                Explore now
                                            </a>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
}
